import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState, useSetRecoilState } from "recoil";
import { DialogMessageState, MoveButtonState } from "../../recoil/states";
import { asyncReqIsLogin, LoginBtnsActions } from '../../reducers/LoginBtnsReducer';
import { AppDispatch, RootState } from "../../Store";
import CommonUtil from "../../utils/CommonUtil";

const LoginBtns = () => {

    const LoginBtnsReducer_Result = useSelector((state: RootState) => state.LoginBtnsReducer); // '로그인 / 로그아웃' 버튼 표시 처리를 위한 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const [moveButtonState, setMoveButtonState] = useRecoilState(MoveButtonState); // '순차 / 랜덤' 버튼 클릭 여부 정보를 갖는 state
    const dispatch = useDispatch<AppDispatch>();

    // 로그인 여부 값 가져오기
    useEffect(() => {

        // 로그인 여부 값 비동기 통신 중, 로딩바 표시 설정
        if (LoginBtnsReducer_Result.asyncIsLogin.status === "LOADING") {
            // 로그인 > 통신 중 일 경우
        }
        else {
            if (LoginBtnsReducer_Result.asyncIsLogin.status === "FAIL") {
                // 로그인 > 통신 실패된 경우

                const message = "로그인 상태 가져오기 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
                setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
            }
            else if (LoginBtnsReducer_Result.asyncIsLogin.status === "COMPLETE") {
                // 로그인 > 통신 성공된 경우

                // 웹뷰에서 콘솔 로그를 확인해고 싶으면 주석 해제!
                /*
                if (LoginBtnsReducer_Result.asyncIsLogin.MEM_UDID === "ea4eea2d77326330") {
                    // vConsole: 특정 UDID일 때만 1회 로드/활성화
                    try {
                        // 이미 활성화되었는지(렌더 반복/재실행 가드)
                        if (!(window as any).__VCONSOLE_ENABLED__) {
                            (window as any).__VCONSOLE_ENABLED__ = true;

                            const enable = () => {
                                try {
                                    // 이미 로드되어 있으면 바로 인스턴스 생성
                                    (window as any).__vconsole = new (window as any).VConsole();
                                    console.log("[vConsole] enabled for UDID ea4eea2d77326330");
                                } catch (e) {
                                    console.warn("[vConsole] init failed:", e);
                                }
                            };

                            // 스크립트가 이미 있으면(중복 로드 방지) → 바로 enable
                            if ((window as any).VConsole) {
                                enable();
                            } else {
                                // CDN에서 동적 주입
                                const s = document.createElement("script");
                                s.src = "https://unpkg.com/vconsole@latest/dist/vconsole.min.js";
                                s.async = true;
                                s.onload = enable;
                                s.onerror = () => {
                                    (window as any).__VCONSOLE_ENABLED__ = false; // 실패 시 가드 해제
                                    console.warn("[vConsole] script load failed");
                                };
                                document.head.appendChild(s);
                            }
                        }
                    } catch (e) {
                        console.warn("[vConsole] error:", e);
                    }
                }
                */

                if (LoginBtnsReducer_Result.asyncIsLogin.isLogin && $("#btnLoginOk").attr("showSucMsgYn") === "Y") {
                    const nickname = LoginBtnsReducer_Result.asyncIsLogin.NICKNAME;
                    const message: React.ReactNode = (
                        <>
                            {nickname ? <div><b style={{ color: '#68b880' }}>{nickname}</b>님,</div> : null}
                            로그인 되었습니다.
                        </>
                    );
                    setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));

                    $("#btnLoginOk").removeAttr("showSucMsgYn"); // 로그인 완료 메세지 중복 표시되지 않도록 관련 속성 값 제거
                    dispatch(LoginBtnsActions.setIsShowLoginPop(false)); // 로그인 레이어 팝업 숨김 요청

                    if (window.location.pathname.startsWith("/board_info")) {
                        // '웃긴사진' 메뉴 일 경우
                        if (moveButtonState.isClickBtnOrder) {
                            // '순차' 버튼이 표시중인 경우

                            // '랜덤' 버튼 클릭 알림
                            setMoveButtonState(rawState => ({ ...rawState, isClickBtnOrder: false, isClickBtnRandom: true }));
                        }
                    }
                }
            }
        }

        return () => { }
    });

    /**
    * 로그인 버튼 클릭 이벤트
    * 
    * @param isShow 표시여부 (ture / false)
    * @returns 
    */
    const handlerLoginBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, isShow: boolean) => {
        e.preventDefault();
        dispatch(LoginBtnsActions.setIsShowLoginPop(isShow));
    }

    /**
    * 로그아웃 버튼 클릭 이벤트
    * 
    * @param 
    * @returns 
    */
    const handlerLogoutBtn = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();

        const message = "로그아웃 하시겠습니까?";
        const callbackFuncOk = () => {
            dispatch(LoginBtnsActions.setIsShowLodingBar(true)); // 로딩바 표시 요청
            dispatch(asyncReqIsLogin({ logout_req_yn: "Y" }));
        }
        setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: true, message, callbackFuncOk }));
    }

    /**
    * SNS 로그인 버튼 클릭 이벤트
    * 
    * @param mode 호출 유형 (NAVER / FACEBOOK)
    * @returns 
    */
    const handlerSnsLoginBtn = (mode: string) => {
        const redirectUrl = process.env.REACT_APP_API_DOMAIN + "/ApiUggiyo/Member/Sns_Login_Callback.aspx?req_code=" + encodeURIComponent(mode);
        if (mode === "NAVER") {
            CommonUtil.win_open(
                process.env.REACT_APP_NAVER_LOGIN_URL + "&redirect_uri=" + encodeURIComponent(redirectUrl)
                , "popup_sns_login"
                , "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,left=200,top=50,width=500,height=500,scrollbars=1"
            );
        }
        else if (mode === "FACEBOOK") {
            CommonUtil.win_open(
                redirectUrl
                , "popup_sns_login"
                , "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,left=200,top=50,width=500,height=500,scrollbars=1"
            );
        }
        else if (mode === "KAKAO") {
            CommonUtil.win_open(
                redirectUrl
                , "popup_sns_login"
                , "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,left=200,top=50,width=500,height=500,scrollbars=1"
            );
        }
        else if (mode === "GOOGLE") {
            CommonUtil.win_open(
                process.env.REACT_APP_GOOGLE_LOGIN_URL + "&redirect_uri=" + encodeURIComponent(redirectUrl)
                , "popup_sns_login"
                , "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=no,left=200,top=50,width=500,height=500,scrollbars=1"
            );
        }
        else {

            const message = "서비스 준비중입니다.";
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
    }

    return (
        <ul className="tnb">
            {
                LoginBtnsReducer_Result.asyncIsLogin.isLogin ?
                    <li><a href="#none" className="gnb_1da login_btn" onClick={handlerLogoutBtn}><i className="fa fa-unlock fa-2x" aria-hidden="true"></i> 로그아웃</a></li>
                    : <li><a href="#none" className="login_btn" onClick={(e) => handlerLoginBtn(e, true)}><i className="fa fa-lock fa-2x" aria-hidden="true"></i> 로그인</a></li>
            }
            <li>
                <div className="member_menu" style={{ display: LoginBtnsReducer_Result.isShowLoginPop ? "block" : "none" }}>
                    <div className="member_div">

                        <section className="login_ui">

                            <div style={{ marginBottom: "20px" }}>
                                <h3>소셜 계정으로 로그인</h3>
                            </div>

                            <div className="sns_button" onClick={() => handlerSnsLoginBtn("NAVER")}>
                                <img src="/images/btn_sns_naver.png" alt="" /><span>네이버 아이디로 로그인</span>
                            </div>
                            <div className="sns_button" onClick={() => handlerSnsLoginBtn("FACEBOOK")}>
                                <img src="/images/btn_sns_facebook.png" alt="" /><span>페이스북 아이디로 로그인</span>
                            </div>
                            <div className="sns_button" onClick={() => handlerSnsLoginBtn("KAKAO")}>
                                <img src="/images/btn_sns_kakaotalk.png" alt="" /><span>카카오 아이디로 로그인</span>
                            </div>
                            <div className="sns_button" onClick={() => handlerSnsLoginBtn("GOOGLE")}>
                                <img src="/images/btn_sns_google.png" alt="" /><span>구글 아이디로 로그인</span>
                            </div>
                        </section>
                        <a href="#none" className="login_cls_btn" onClick={(e) => handlerLoginBtn(e, false)}><i className="fa fa-times fa-3x" aria-hidden="true"></i> </a>

                    </div>
                </div>
            </li>
        </ul>
    )
}

export default LoginBtns;
